<template>
    <div>
        <label :for="id" v-if="!!label">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <b-form-select
            v-bind="$attrs"
            v-on="$listeners"
            :value-field="valueField"
            :text-field="textField"
            :state="isValid"
        ></b-form-select>
        <span v-if="hasError && !!errorMessage" class="field-error">{{ errorMessage }}</span>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String
        },
        id: {
            type: String,
            default: () => `select-${parseInt(Math.random()*10000000000)}`
        },
        hasError: {
            type: Boolean,
            default: () => false
        },
        errorMessage: {
            type: String,
            default: ''
        },
        valueField: {
            type: String,
            default: 'value'
        },
        textField: {
            type: String,
            default: 'text'
        },
        required: {
            type: Boolean,
            default: () => false
        },
    },
    computed: {
        isValid() {
            return this.hasError? false: null;
        }
    },
}
</script>